export const STEP_CUSTOMER = {
  analyticsStepName: 1,
  path: 'loan/customer',
  routerPath: 'customer',
  type: 'CUSTOMER',
};

export const STEP_NORDIGEN = {
  path: 'loan/offer/nordigen',
  routerPath: 'offer/nordigen',
  type: 'NORDIGEN',
  hideFromProgressBar: true,
};

export const STEP_PRODUCT = {
  path: 'loan/offer',
  routerPath: 'offer',
  type: 'PRODUCT',
};

export const STEP_PROVIDENT_PRODUCT = {
  path: 'loan/rejection-with-provi-offer',
  routerPath: 'rejection-with-provi-offer',
  type: 'STEP_PROVIDENT_PRODUCT',
};

export const STEP_REIDENTIFY_CUSTOMER = {
  analyticsStepName: 1,
  path: 'loan/reidentify-customer',
  routerPath: 'reidentify-customer',
  type: 'REIDENTIFY_CUSTOMER',
};

export const STEP_SYSTEM_AUTHORITY = {
  path: 'loan/verify-income-tax',
  routerPath: 'verify-income-tax',
  type: 'SYSTEM_AUTHORITY',
};

export const STEP_LOAN_PURPOSE = {
  path: 'loan/loan-purpose',
  routerPath: 'loan-purpose',
  type: 'LOAN_PURPOSE',
};

export const STEP_PSYCHOMETRIC = {
  path: 'loan/surveyapp',
  routerPath: 'surveyapp',
  type: 'PSYCHOMETRIC',
};

export const STEP_SUBMIT = {
  path: 'loan/offer/submit',
  routerPath: 'submit',
  type: 'SUBMIT',
  hideFromProgressBar: true,
  analyticsStepName: 'legal',
};

export const STEP_INFORMATION = {
  path: 'loan/offer/servicesaus-retrieval-failed',
  routerPath: 'servicesaus-retrieval-failed',
  type: 'INFORMATION',
  hideFromProgressBar: true,
  analyticsStepName: 'sacc_information',
};

export const STEP_ALMOST_THERE = {
  path: 'loan/offer/almost-there',
  routerPath: 'almost-there',
  type: 'ALMOST_THERE',
  hideFromProgressBar: true,
  analyticsStepName: 'sacc',
};

export const STEP_SACC_LOADING = {
  path: 'loan/offer/servicesaus-retrieval-loading',
  routerPath: 'servicesaus-retrieval-loading',
  type: 'SACC_LOADING',
  hideFromProgressBar: true,
  analyticsStepName: 'sacc_loading',
};

export const STEP_EMAIL_VERIFICATION = {
  path: 'loan/offer/email-verification',
  routerPath: 'email-verification',
  type: 'EMAIL_VERIFICATION',
  hideFromProgressBar: true,
  analyticsStepName: 'email_verification',
};

export const STEP_LOAN_PURPOSE_AU = {
  path: 'loan/offer/loan-purpose',
  routerPath: 'loan-purpose',
  type: 'LOAN_PURPOSE',
  hideFromProgressBar: true,
  analyticsStepName: 'loan_purpose',
};
